/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
	props: {
		id: {
			type: Number,
			required: true,
		},
		type: {
			type: String,
			default: 'page',
		},
	},
	data() {
		return {
			post: null,
			loading: true,
		};
	},
	watch: {
		id() {
			this.fetchContent();
		},
	},
	created() {
		this.fetchContent();
	},
	methods: {
		fetchContent() {
			const vm = this;
			const endpoint = this.type === 'post' ? 'posts' : 'pages';

			vm.loading = true;
			vm.post = null;

			fetch( ui_data.homeUrl + '/wp-json/wp/v2/' + endpoint + '/' + this.id + '?_embed=1' )
				.then( function ( response ) {
					return response.json();
				} )
				.then( function ( post ) {
					vm.post = post;
					vm.loading = false;
				} )
				.catch( function () {
					vm.loading = false;
				} );
		},
		postImage() {
			const media = this.post && this.post._embedded && this.post._embedded['wp:featuredmedia'];

			if ( media && media[0] && media[0].source_url ) {
				return media[0].source_url;
			}

			return '';
		},
		formatDate( date ) {
			return new Date( date ).toLocaleDateString( 'en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			} );
		},
	},
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"container content-page-loading"},[_c('p',[_vm._v("Loading...")])]):(_vm.post)?[(_vm.type === 'post')?_c('header',{staticClass:"entry-header single-article-header"},[_c('h1',{staticClass:"entry-title",domProps:{"innerHTML":_vm._s(_vm.post.title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"entry-meta"},[_c('time',{attrs:{"datetime":_vm.post.date}},[_vm._v(_vm._s(_vm.formatDate( _vm.post.date )))])])]):_vm._e(),_vm._v(" "),(_vm.postImage())?_c('div',{staticClass:"container single-post-thumbnail"},[_c('img',{attrs:{"src":_vm.postImage(),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container ui-single-article-wrapper"},[_c('article',{class:['content-page', 'content-page--' + _vm.type],attrs:{"id":'post-' + _vm.post.id}},[(_vm.type === 'page')?_c('header',{staticClass:"entry-header"},[_c('h1',{staticClass:"entry-title",domProps:{"innerHTML":_vm._s(_vm.post.title.rendered)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"entry-content",domProps:{"innerHTML":_vm._s(_vm.post.content.rendered)}})])])]:_c('div',{staticClass:"container content-page-not-found"},[_c('p',[_vm._v("Content not found.")])])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContentPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__